import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faCopy,
  faDatabase,
  faMessageQuote,
  faPencil,
  IconDefinition,
} from '@fortawesome/pro-light-svg-icons';
import React, { useMemo } from 'react';
import {
  RagDocumentReference,
  Role,
  TaskMessageResponseSource,
} from '../../graphql/schema';
import useUser from '../../helper/useUser';
import { useSidebarLayout } from '../sidebar/SidebarLayout';
import MessageSources from './MessageSources';
import MessageRagDocumentReferences from './MessageRagDocumentReferences';

interface Props {
  onEdit?: () => void;
  onCopy?: () => void;
  sources?: TaskMessageResponseSource[] | null;
  ragDocumentReferences?: RagDocumentReference[];
}

interface Button {
  key: string;
  label: string;
  icon: IconDefinition;
  onClick?: () => void;
}

const MessageFooter = ({
  onEdit,
  onCopy,
  sources,
  ragDocumentReferences,
}: Props) => {
  const { hasRole } = useUser();
  const isAdmin = hasRole([Role.SYSTEM_ADMIN]);
  const { setRightSidebarContent } = useSidebarLayout();

  const buttons = useMemo(() => {
    const buttons: Button[] = [];

    if (onEdit) {
      buttons.push({
        key: 'edit',
        onClick: onEdit,
        icon: faPencil,
        label: 'Bearbeiten',
      });
    }

    if (onCopy) {
      buttons.push({
        key: 'copy',
        onClick: onCopy,
        icon: faCopy,
        label: 'Kopieren',
      });
    }

    if (sources && sources.length > 0) {
      buttons.push({
        key: 'edit',
        onClick: () =>
          setRightSidebarContent(<MessageSources sources={sources} />),
        icon: faMessageQuote,
        label: 'Quellen',
      });
    }

    if (ragDocumentReferences && ragDocumentReferences.length > 0 && isAdmin) {
      buttons.push({
        key: 'rag',
        onClick: () =>
          setRightSidebarContent(
            <MessageRagDocumentReferences
              ragDocumentReferences={ragDocumentReferences}
            />,
          ),
        icon: faDatabase,
        label: 'RAG',
      });
    }

    return buttons;
  }, [
    onEdit,
    onCopy,
    sources,
    ragDocumentReferences,
    isAdmin,
    setRightSidebarContent,
  ]);

  return (
    <div className="w-full opacity-100 lg:opacity-0 group-hover:opacity-100 space-x-5 flex flex-row mt-1">
      {buttons.map((button: Button) => (
        <div
          key={button.key}
          className="text-xs flex flex-row space-x-1 items-center cursor-pointer opacity-30 hover:opacity-100"
          onClick={button.onClick}
        >
          <FontAwesomeIcon icon={button.icon} />
          <span>{button.label}</span>
        </div>
      ))}
    </div>
  );
};

export default MessageFooter;
